import React from 'react';
import { Container, Typography, Box, List, ListItem, ListItemText, Paper } from '@mui/material';
import exampleimg from "../assets/images/tv-export-example.png";
import exampleimg2 from "../assets/images/tv-export-config-example.png";
import { useTranslation } from '../context/TranslationContext';

const Instructions = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md" style={{ padding: '20px' }}>
      <Typography variant="body1" style={{ color: 'red', fontWeight: 'bold', marginBottom: '20px' }}>
        {t("Note: There are still calculation bugs. Please use with care.")}
      </Typography>
      
      <Typography variant="h4" gutterBottom style={{ borderBottom: '2px solid #ddd', paddingBottom: '10px' }}>
        {t("How to Import Your Trading Data:")}
      </Typography>
      <Typography variant="body1">
        {t("Follow these steps to ensure accurate calculations and proper management of your trading data.")}
      </Typography>
      <Box my={2}>
        <img src={exampleimg} alt="Example" style={{ width: '100%', height: 'auto' }} />
      </Box>
      <Box my={2}>
        <Typography variant="h5" gutterBottom>{t("Step 1:")}</Typography>
        <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
          <Typography variant="h6">{t("Export CSV Files from TradingView:")}</Typography>
          <List>
            <ListItem>
              <ListItemText primary={t("Open the tab 'List of Trades' in the TradingView backtester as shown in the image above.")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("Click the Download button (also highlighted in the image) to export your trading list as CSV files.")} />
            </ListItem>
          </List>
        </Paper>
      </Box>
      <Box my={2}>
        <Typography variant="h5" gutterBottom>{t("Step 2:")}</Typography>
        <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
          <Typography variant="h6">{t("Upload CSV Files to the Application:")}</Typography>
          <List>
            <ListItem>
              <ListItemText primary={t('Navigate to the "Manage Data" page from the menu.')} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("Upload the exported CSV files.")} />
            </ListItem>
          </List>
        </Paper>
      </Box>
      <Box my={2}>
        <Typography variant="h5" gutterBottom>{t("Step 3:")}</Typography>
        <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
          <Typography variant="h6">{t("Manage Uploaded Files:")}</Typography>
          <List>
            <ListItem>
              <ListItemText primary={t("Each uploaded file can be included in calculations by selecting it.")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("You can assign a custom name to each file for better identification.")} />
            </ListItem>
          </List>
        </Paper>
      </Box>
      <Box my={2}>
        <Typography variant="h5" gutterBottom>{t("Step 4:")}</Typography>
        <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
          <Typography variant="h6">{t("Initial Equity Adjustment:")}</Typography>
          <List>
            <ListItem>
              <ListItemText primary={t("The initial amount of equity is estimated by reverse-calculating from your trading data. However, this may not always produce accurate results.")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("After uploading each file, you can manually edit and input the correct initial equity if needed.")} />
            </ListItem>
          </List>
        </Paper>
      </Box>
      <Typography variant="h4" gutterBottom style={{ borderTop: '2px solid #ddd', paddingBottom: '10px', paddingTop: '20px' }}>
        {t("(Optional) How to Import And Remember Your Backtest Configuration:")}
      </Typography>
      <Box my={2}>
        <img src={exampleimg2} alt="Example" style={{ width: '100%', height: 'auto' }} />
      </Box>
      <Box my={2}>
        <Typography variant="h5" gutterBottom>{t("Step 1:")}</Typography>
        <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
          <Typography variant="h6">{t("Export Configuration:")}</Typography>
          <List>
            <ListItem>
              <ListItemText primary={t("Navigate to the 'Configuration' page in the TradingView backtester.")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("Click the 'Export' button to save your current configuration.")} />
            </ListItem>
          </List>
        </Paper>
      </Box>
      <Box my={2}>
        <Typography variant="h5" gutterBottom>{t("Step 2:")}</Typography>
        <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
          <Typography variant="h6">{t("Import Configuration:")}</Typography>
          <List>
            <ListItem>
            <ListItemText primary={t('Navigate to the "Manage Data" page from the menu.')} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("Click the 'Import' button in the config column of your entries row and upload the exported csv file.")} />
            </ListItem>
          </List>
        </Paper>
      </Box>
      <Box my={2}>
        <Typography variant="h5" gutterBottom>{t("Step 3:")}</Typography>
        <Paper elevation={3} style={{ padding: '20px', marginBottom: '20px' }}>
          <Typography variant="h6">{t("Manage Configuration:")}</Typography>
          <List>
            <ListItem>
              <ListItemText primary={t("You can view your configuration again as needed by clicking on the eye icon.")} />
            </ListItem>
          </List>
        </Paper>
      </Box>
    </Container>
  );
};

export default Instructions;
